<template>
    <div class="signing-top pdf-viewer-top">
        <div class="top">
            <div class="content">
                <h1>{{ $t('review-sign.contract.headline') }}</h1>
                <p v-if="customContract.property"> {{ customContract.property.address }}</p>
            </div>
        </div>
        <div v-if="step !== 'success'" class="progress-bar">
            <div class="content">
                <div class="col" :class="{active: isActive('review'), done: isDone('review')}">
                    <div class="dot">
                        <svg v-if="isDone('review')"
                             xmlns="http://www.w3.org/2000/svg"
                             width="9.895"
                             height="7.38"
                             viewBox="0 0 19.79 14.76">
                            <path class="fill-white"
                                  d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z"
                                  transform="translate(-1311.12 -1083.12)"/>
                        </svg>
                    </div>
                    <p>{{ $t('review-sign.steps.review') }}</p>
                </div>
                <div class="col" :class="{active: isActive('sign'), done: isDone('sign')}">
                    <div class="dot">
                        <svg v-if="isDone('sign')"
                             xmlns="http://www.w3.org/2000/svg"
                             width="9.895"
                             height="7.38"
                             viewBox="0 0 19.79 14.76">
                            <path class="fill-white"
                                  d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z"
                                  transform="translate(-1311.12 -1083.12)"/>
                        </svg>
                    </div>
                    <p>{{ $t('review-sign.steps.sign') }}</p>
                </div>
                <div v-if="extra" class="col" :class="{active: isActive('extra-sign'), done: isDone('extra-sign')}">
                    <div class="dot">
                        <svg v-if="isDone('extra-sign')"
                             xmlns="http://www.w3.org/2000/svg"
                             width="9.895"
                             height="7.38"
                             viewBox="0 0 19.79 14.76">
                            <path class="fill-white"
                                  d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z"
                                  transform="translate(-1311.12 -1083.12)"/>
                        </svg>
                    </div>
                    <p>{{ $t('review-sign.steps.sign') }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import customContractMixin, {
    ROLE_TENANT,
} from '../../../mixins/custom-contract';

export default {
    name: "CustomContractSignHeader",
    props: ['customContract', 'step', 'extra'],
    mixins: [customContractMixin],
    methods: {
        isDone(step) {
            if (this.step === 'success')
                return true;

            if (step === 'review' && ['sign', 'extra-sign', 'success-first-sign'].includes(this.step))
                return true;

            if (step === 'sign' && this.step === 'extra-sign')
                return true;

            if (step === 'sign' && this.step === 'success-first-sign')
                return true

            if (this.step === 'review'
                && _.filter(this.customContract.tenants, {'is_signed': true}).length === this.customContract.tenants.length
                && step === 'sign'
                && this.getContractStatusSet(this.customContract).includes(ROLE_TENANT))
                return true;

            return false;

        },
        isActive(step) {
            return this.step === step;
        }
    }
}
</script>

<style scoped>

</style>
